// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__IvfLv","image":"styles_image__HQHy9","text":"styles_text__28CnA","show":"styles_show__1Hgjl","hero":"styles_hero__3Z2L3"};